import React from "react";
import { Redirect } from "react-router";
import { apiClient } from "../App";

interface Props {}

const Logout: React.FC<Props> = () => {
  apiClient.token = null;
  return <Redirect to="/" />;
};

export default Logout;
